import { CollaboratorTypeEnum } from "../constants/AppConstants";
import {
  FOLLOW_COLLABOLATORS_LABEL,
  ACTIVE_RESOURCES_LABEL,
} from "../constants/Dictionary";
import { AuthProfile } from "../types/api/auth.type";
import { CollaboratorInfo } from "../types/AppTypes";
import { roleHasPermission } from "./roleAuth.utils";

export const filterCollaborators = (
  collaborators: CollaboratorInfo[],
  filters: {
    area: string[];
    practice: string[];
    cc: string[];
    internalGrade: string[];
  },
): CollaboratorInfo[] =>
  collaborators.filter(
    (item) =>
      (filters.area.length === 0 ||
        (item.area !== null && filters.area.includes(item.area))) &&
      (filters.practice.length === 0 ||
        (item.practice !== null && filters.practice.includes(item.practice))) &&
      (filters.cc.length === 0 ||
        (item.cc !== null && filters.cc.includes(item.cc))) &&
      (filters.internalGrade.length === 0 ||
        (item.internalGrade !== null &&
          filters.internalGrade.includes(item.internalGrade))),
  );

export const getInitials = (name: string, surname: string): string => {
  const firstInitial = surname?.charAt(0) || "";
  const secondInitial = name?.charAt(0) || "";
  return `${firstInitial}${secondInitial}`.toUpperCase();
};

export const getCollaboratorsTabs = (profile: AuthProfile) => {
  return [
    ...(roleHasPermission(profile, CollaboratorTypeEnum.FOLLOW)
      ? [
          {
            value: CollaboratorTypeEnum.FOLLOW,
            label: FOLLOW_COLLABOLATORS_LABEL,
          },
        ]
      : []),
    ...(roleHasPermission(profile, CollaboratorTypeEnum.ACTIVE)
      ? [
          {
            value: CollaboratorTypeEnum.ACTIVE,
            label: ACTIVE_RESOURCES_LABEL,
          },
        ]
      : []),
  ];
};
